/* MAIYKO EKLENTI — ön sipariş koçanı sayacı (v17, 16 Eyl).
   Liquid ilk görünümü basar; bu betik kademe listesini (data-os-kademeler) tarayıcı
   saatine göre yeniden hesaplar: aktif kademe, kalan süre (gün/sa/dk), sonraki fiyat
   ve takvimde geçen/şimdi/yakında sınıfları. 30 sn'de bir yeniler. Fail-open:
   veri yoksa hiçbir şeye dokunmaz. */
(function () {
  'use strict';
  var AY = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
  function tl(n) { return Number(n).toLocaleString('tr-TR') + '₺'; }
  function tarih(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function bitis(k) { if (!k.bit) return new Date(2100, 0, 1); var t = tarih(k.bit); t.setDate(t.getDate() + 1); return t; }
  function gun(s) { var t = tarih(s); return t.getDate() + ' ' + AY[t.getMonth()]; }
  function metin(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function kur(el) {
    var kademeler;
    try { kademeler = JSON.parse(el.getAttribute('data-os-kademeler') || '[]'); } catch (e) { return; }
    if (!kademeler || !kademeler.length) return;
    var sayacEl = el.querySelector('[data-os-sayac]');
    var sonrakiEl = el.querySelector('[data-os-sonraki]');
    var satirlar = el.querySelectorAll('[data-os-kademe]');
    var sonraSablon = el.getAttribute('data-os-sonra') || 'Sonra [fiyat] · [tarih]';
    var sonMetin = el.getAttribute('data-os-son-metin') || 'Son fiyat';
    var sonAlt = el.getAttribute('data-os-son-alt') || '';
    var gecenGizle = el.getAttribute('data-os-gecen-gizle') === '1';

    function tik() {
      var now = new Date(), aktif = null, sonraki = null;
      for (var i = 0; i < kademeler.length; i++) {
        var k = kademeler[i];
        if (now >= tarih(k.bas) && now < bitis(k)) { aktif = k; sonraki = kademeler[i + 1] || null; }
      }
      if (!aktif) {
        if (now < tarih(kademeler[0].bas)) { sonraki = kademeler[0]; }
        else { aktif = kademeler[kademeler.length - 1]; sonraki = null; }
      }
      for (var j = 0; j < satirlar.length; j++) {
        var kk = kademeler[j]; if (!kk) continue;
        var s = now >= bitis(kk) ? 'gecti' : (now >= tarih(kk.bas) ? 'simdi' : 'yakinda');
        satirlar[j].className = 'kz-os__kademe is-' + s;
        if (gecenGizle) satirlar[j].hidden = (s === 'gecti');
      }
      if (!sayacEl || !sonrakiEl) return;
      if (aktif && sonraki) {
        var ms = bitis(aktif) - now; if (ms < 0) ms = 0;
        var g = Math.floor(ms / 864e5), sa = Math.floor(ms % 864e5 / 36e5), dk = Math.floor(ms % 36e5 / 6e4);
        sayacEl.innerHTML = (g ? '<b>' + g + '</b><small>gün</small>' : '') + '<b>' + sa + '</b><small>sa</small><b>' + dk + '</b><small>dk</small>';
        sonrakiEl.innerHTML = metin(sonraSablon).replace('[fiyat]', '<b>' + tl(sonraki.fiyat) + '</b>').replace('[tarih]', metin(gun(sonraki.bas)));
      } else if (!aktif && sonraki) {
        sayacEl.innerHTML = '<b>' + metin(gun(sonraki.bas)) + '</b>';
        sonrakiEl.innerHTML = metin(sonraSablon).replace('[fiyat]', '<b>' + tl(sonraki.fiyat) + '</b>').replace('[tarih]', metin(gun(sonraki.bas)));
      } else {
        sayacEl.innerHTML = '<b>' + metin(sonMetin) + '</b>';
        sonrakiEl.textContent = sonAlt;
      }
    }
    tik();
    setInterval(tik, 30000);
  }

  function basla() {
    var hepsi = document.querySelectorAll('[data-os]');
    for (var i = 0; i < hepsi.length; i++) kur(hepsi[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();
